import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contract-type',
  templateUrl: './contract-type.component.html',
  styleUrls: ['./contract-type.component.css']
})
export class ContractTypeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
